<template>
    <stats-card :title="title"
                :type="'gradient-'+type"
                class="mb-4 mb-xl-0">
        <template v-slot:header v-if="showHeader">
            <div class="row align-items-center">
                <div class="col">
                    <h6 class="text-uppercase text-muted ls-1 mb-1">Servicedesk</h6>
                </div>
                <div class="col-auto">
                    <div class="icon icon-shape"><i class="fad fa-tasks text-success" aria-hidden="true"></i></div>
                </div>
            </div>
            <hr class="mb-3 mt-1">
        </template>
        <div class="row mb-5">
            <div class="col">
                <h6 class="text-uppercase text-muted ls-1 mb-1">Assets</h6>
                <h5 class="h3 mb-0">Baum</h5>
            </div>
        </div>
        <TreeChart theme="light" ref="treeChart"/>
        <span v-if="error.length > 0" class="alert-inner--text"><strong>Fehler!</strong>  {{ error }}</span>
        <template v-slot:footer>
        </template>
    </stats-card>
</template>
<script>
import {ref, watch, onMounted} from 'vue';
import {
    ElDropdownMenu,
    ElDropdownItem,
    ElDropdown,
    ElInput,
    ElSelect,
    ElOption
} from "element-plus";
import Card from '@/components/Cards/Card';
import UserService from '@/services/user.service';
import TreeChart from '@/components/Charts/TreeChart';
import 'moment/locale/de';

export default {
    name: 'IncidentChartCategory',
    components: {
        Card,
        TreeChart,
        [ElDropdown.name]: ElDropdown,
        [ElDropdownItem.name]: ElDropdownItem,
        [ElDropdownMenu.name]: ElDropdownMenu,
        [ElInput.name]: ElInput,
        [ElSelect.name]: ElSelect,
        [ElOption.name]: ElOption,
    },
    props: {
        type: {
            type: String,
            default: "orange"
        },
        title: {
            type: String,
            default: "Kategorien"
        },
        showHeader: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        const error = ref('');

        function getError(request) {
            if (request.response && request.response.status == '401') {
                error.value = 'you are not logged in!';
            } else if (request.response && request.response.status == '403') {
                error.value = 'you are not permitted!';
            } else {
                error.value =
                    (request.response && request.response.data) ||
                    request.message ||
                    request.toString();
            }
        }

        const activeTree = ref('');
        const topdeskData = ref({});
        const treeChart = ref({});

        function getChartData() {
            UserService.getAssets().then(
                response => {
                    response.data.tree.children.forEach(function (datum, index) {
                        datum.collapsed = true;
                    });
                    treeChart.value.option.series[0].data = [response.data.tree];
                    treeChart.value.option.series[0].name = "Asset";
                },
                error => {
                    getError(error);
                }
            );
        }

        onMounted(() => {
            getChartData();
        });

        return {
            error,
            treeChart,
            activeTree,
            topdeskData,
            getChartData,
        }
    }
}
</script>

<style lang="scss">
:root {
    --ck-border-radius: 0.375rem;
}

.chartCard {
    margin-bottom: 0;
    box-shadow: inherit !important;
}
</style>

